import { keysToSnake } from '#/api/adapters/wireCase';

/**
 * 憑證 create／update body：可送 totalAmount；禁送 status。
 */
export function toVoucherWriteBody(payload = {}) {
  const {
    status: _status,
    id: _id,
    ...rest
  } = payload ?? {};

  return keysToSnake(rest);
}
